import { TritonPlayerBuilder } from './TiritonPlayerBuilder';
import { TritonAudioStreamConnectionConfig } from './TritonAudioStreamConnection';
import { createTritonPlayerBuilder } from './internal/TritonMediaPlayerBuilder';
import { createCompanionAdModule } from './vast/CompanionAdBannerModule';
import { CompanionBannerModule } from './vast/model/CompanionModule';

const version = '__buildVersion__';

export {
  TritonPlayerBuilder,
  TritonAudioStreamConnectionConfig,
  createTritonPlayerBuilder,
  version,
  createCompanionAdModule,
  CompanionBannerModule,
};
